import { createSlotsContext } from "@grandvisionhq/slots";
const [PaymentSlotsProvider, usePaymentSlots] = createSlotsContext({
  displayName: "CartSlotsContext"
});
export {
  PaymentSlotsProvider,
  usePaymentSlots
};
//# sourceMappingURL=context.js.map
